import {
    faEllipsisVertical,
    faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
    Table,
} from "react-bootstrap";
import { Build_Img, Delete_2, Edit_2, Filters } from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import WardListingFunctions from "./functions";
import PaginationComponent from "../../../CommanComponents/Pagination";
import { renderImage } from "../../../../Helper/General";
import Loader from "../../../../Helper/loader";
import DeleteModal from "../../../Modals/DeleteModal";
import store from "../../../../../redux/store";
import { setDrawer } from "../../../../../redux/actions/users";
import NoDataComponent from "../../../CommanComponents/NoDataComponent";

const Wards = () => {
    const {
        getWardListing,
        wardsListing,
        handleBackClick,
        handleNextClick,
        handleChange,
        page,
        setPage,
        totalPages,
        setTotalPages,
        itemsPerPage,
        setItemsPerPage,
        searchInput,
        setSearchInput,
        breadcrumData,
        breadcrumItem,
        navigate,
        loader,
        setLoader,
        handlePage,
        handleBreadcrumDataNaviagtion,
        deletePopup,
        setDeletePopup,
        count,
        totalCount,
        searchWard,
        updateWardStatus,
        handleDeleteWard,
        deleteItem,
        setDeleteItem,
    } = WardListingFunctions();

    useEffect(() => {
        if (!loader) {
            getWardListing();
        }
    }, []);

    const handleDrawer = async (e) => {
        await store.dispatch(setDrawer(false));
    };

    const [showFilterModal, setShowFilterModal] = useState(false);

    return (
        <div className="role_list_screen ward_list_area">
            <WithoutImageHeader
                header={Constants.WARDLIST}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                lefticon={"menu"}
                handleBreadcrumDataNaviagtion={(i) =>
                    handleBreadcrumDataNaviagtion(i)
                }
            />
            <Container onClick={() => handleDrawer()}>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="role_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>
                                       Total Ward: {totalCount ? totalCount : 0}
                                    </p>
                                </div>
                                <div className="right_area">
                                    <a
                                        className="btn btn-primary"
                                        href="/add-Ward"
                                    >
                                        Add Ward
                                    </a>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                                value={searchInput}
                                                onChange={(e) =>
                                                    searchWard(e.target.value)
                                                }
                                            />
                                            <a>
                                                <div className="icon">
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                    />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="filter_button">
                                    <Button className="btn-primary"
                                        onClick={() => setShowFilterModal(true)}>
                                        <Image src={Filters} alt="..." className="image_area" />Filters</Button>
                                </div>
                            </div>
                            {loader ? (
                                <Loader loader={loader} />
                            ) : (
                                <>
                                    {!loader &&wardsListing && wardsListing.length > 0 ? (
                                        <div className="list_detail">
                                            <div className="list_data">
                                                <Table responsive>
                                                    <tr>
                                                        <th className="role_text">
                                                            Hospital Name
                                                        </th>
                                                        <th>Ward Name</th>
                                                        <th>Ward Number</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {wardsListing &&
                                                        wardsListing.length > 0
                                                        ? wardsListing.map(
                                                              (item, index) => (
                                                                  <tr key={index}>
                                                                      <td>
                                                                          <div className="profile_info">
                                                                              <div className="left_area">
                                                                                  <div className="img_profile">
                                                                                      <Image
                                                                                          src={
                                                                                              item &&
                                                                                              item.hospitals &&
                                                                                              item
                                                                                                  .hospitals[0] &&
                                                                                              item
                                                                                                  .hospitals[0]
                                                                                                  .image
                                                                                                  ? renderImage(
                                                                                                        item
                                                                                                            .hospitals[0]
                                                                                                            .image
                                                                                                    )
                                                                                                  : Build_Img
                                                                                          }
                                                                                          alt="..."
                                                                                      />
                                                                                  </div>
                                                                              </div>
                                                                              <div className="right_area">
                                                                                  <p>
                                                                                      {item &&
                                                                                      item.hospitals &&
                                                                                      item
                                                                                          .hospitals[0] &&
                                                                                      item
                                                                                          .hospitals[0]
                                                                                          .hospital_name
                                                                                          ? item
                                                                                                .hospitals[0]
                                                                                                .hospital_name
                                                                                          : null}
                                                                                  </p>
                                                                              </div>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className="label">
                                                                              <p>
                                                                                  {
                                                                                      item.title
                                                                                  }
                                                                              </p>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          {
                                                                              item.ward_number
                                                                          }
                                                                      </td>
                                                                      <td>
                                                                          <div className="switch_area">
                                                                              <Form>
                                                                                  <Form.Check
                                                                                      type="switch"
                                                                                      id="custom-switch"
                                                                                      label={
                                                                                          parseInt(
                                                                                              item.status
                                                                                          ) ===
                                                                                          1
                                                                                              ? "Active"
                                                                                              : "Deactivate"
                                                                                      }
                                                                                      checked={
                                                                                          parseInt(
                                                                                              item.status
                                                                                          ) ===
                                                                                          1
                                                                                              ? true
                                                                                              : false
                                                                                      }
                                                                                      onClick={() =>
                                                                                          updateWardStatus(
                                                                                              item
                                                                                          )
                                                                                      }
                                                                                  />
                                                                              </Form>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className="icon">
                                                                              <Dropdown>
                                                                                  <Dropdown.Toggle
                                                                                      variant="none"
                                                                                      id="dropdown-basic"
                                                                                  >
                                                                                      <FontAwesomeIcon
                                                                                          icon={
                                                                                              faEllipsisVertical
                                                                                          }
                                                                                          className="ellipsis_icon"
                                                                                      />
                                                                                  </Dropdown.Toggle>
                                                                                  <Dropdown.Menu>
                                                                                      <Dropdown.Item
                                                                                          onClick={() =>
                                                                                              navigate(
                                                                                                  "/add-Ward",
                                                                                                  {
                                                                                                      state: {
                                                                                                          name: "EditWard",
                                                                                                          id: item.id,
                                                                                                      },
                                                                                                  }
                                                                                              )
                                                                                          }
                                                                                      >
                                                                                          Edit
                                                                                          <Image
                                                                                              src={
                                                                                                  Edit_2
                                                                                              }
                                                                                              alt="..."
                                                                                              className="image_area"
                                                                                          />
                                                                                      </Dropdown.Item>
                                                                                      <Dropdown.Item
                                                                                          onClick={() => (
                                                                                              setDeleteItem(
                                                                                                  item
                                                                                              ),
                                                                                              setDeletePopup(
                                                                                                  true
                                                                                              )
                                                                                          )}
                                                                                      >
                                                                                          Delete
                                                                                          <Image
                                                                                              src={
                                                                                                  Delete_2
                                                                                              }
                                                                                              alt="..."
                                                                                              className="image_area delete_icon "
                                                                                          />
                                                                                      </Dropdown.Item>
                                                                                  </Dropdown.Menu>
                                                                              </Dropdown>
                                                                          </div>
                                                                      </td>
                                                                  </tr>
                                                              )
                                                          )
                                                        : null}
                                                </Table>
                                            </div>
                                        </div>
                                    ) : (
                                        <NoDataComponent message="No wards founds!" />
                                    )}
                                </>
                            )}
                            {!loader &&
                                wardsListing &&
                                wardsListing.length > 0 ? (
                                <PaginationComponent
                                    page={page}
                                    setPage={handlePage}
                                    totalPages={totalPages}
                                    handleBackClick={handleBackClick}
                                    handleNextClick={handleNextClick}
                                />
                            ) : null}
                        </div>
                        {/* } */}
                    </Col>
                </Row>
            </Container>

            {deletePopup ? (
                <DeleteModal
                    show={deletePopup}
                    handleSubmit={() => handleDeleteWard()}
                    close={() => setDeletePopup(false)}
                    message={"Do you want to delete this ward?"}
                />
            ) : null}
        </div>
    );
};

export default Wards;
